import React, { useState, useEffect, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import axios from "axios";
import { UpwardReduxInput } from "../ui";
import FormValidators from "../FormValidators/index";

const EasyApplyForm = (props) => {

    const [count, setCount] = useState(0);

    useEffect(() => {
        document.getElementById("fname").focus();
    }, []);

    useEffect(() => {
        if(count === 1){
          document.getElementById("lname").select();
          document.getElementById("lname").focus();
          document.getElementById("fname").focus();
          setCount(count + 1);
        }
      });

    const easyQuery = {
        "id" : "",
        "removeWork" : "",
        "title" : props.recentJob,
        "company" : props.recentCompany,
        "workExp" : "yes",
        "isCurrent" : "true",
    }

    let resumeCB = document.getElementsByClassName('resumeOptinRadio');
    let optinsQuery;
    if(resumeCB.length > 0){
        let confirmations = resumeCB.checked.map(function(i,item){ return item.value}).get().filter(function(item){ return item !== "" }).join(",");
        optinsQuery = {
            optin_advertisers : confirmations,
            _ : + new Date()
        }
    } else {
        optinsQuery = {
            regOid : 3919,
            optin_advertisers : (window.optinsHandler.resumeOptinId || ""),
            _ : + new Date()
        }
    }

    let headersConfig = {
        headers : {
            "X-Requested-With" : "XMLHttpRequest",
            "Cache-Control" : "no-cache"
        }
    }

    const easyQueryString = Object.keys(easyQuery).map(key => key + '=' + easyQuery[key]).join('&');
    const optinsQueryString = Object.keys(optinsQuery).map(key => key + '=' + optinsQuery[key]).join('&');

    const handleSubmit = () => {

    props.showLoad();

    if(props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus"){
        axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/search/internalPost2.fsn?OID=3003&CRID=0&" + props.queryString),
            //axios.get('/accountSignup.jsp?noeml=true&OID=3002&' + props.queryString),
            axios.post(process.env['REACT_APP_API_URL'] + "/upward/employee/updateResume2.jsp?" + easyQueryString),
            axios.get(process.env['REACT_APP_API_URL'] + "/upward/employee/update_profile.jsp?" + props.queryString),
            axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp", props.queryString3, headersConfig),
        ])
        .then(responseArr => {
            if(window.optinsHandler.resumeOptinId !== undefined && window.optinsHandler.resumeOptinId !== ''){
                axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
            }
            props.hideLoad();
            props.onFormSubmit('customForm');
        }, (error) => {
            props.hideLoad();
            console.log(error);
        });
    }else{
        axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/search/internalPost2.fsn?OID=3003&CRID=0&" + props.queryString),
            //axios.get('/accountSignup.jsp?noeml=true&OID=3002&' + props.queryString),
            axios.post(process.env['REACT_APP_API_URL'] + "/upward/employee/updateResume2.jsp?" + easyQueryString),
            axios.get(process.env['REACT_APP_API_URL'] + "/upward/employee/update_profile.jsp?" + props.queryString),
        ])
        .then(responseArr => {
            if(window.optinsHandler.resumeOptinId !== undefined && window.optinsHandler.resumeOptinId !== ''){
                axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
            }
            props.hideLoad();
            props.onFormSubmit('customForm');
        }, (error) => {
            props.hideLoad();
            console.log(error);
        });
    }

    }

    return (
        <Fragment>
            <a href="#" onClick={() => props.onFormSubmit('uploadResume')}>back</a>
            <h3>Easy Apply</h3>
            <form onSubmit={props.handleSubmit(handleSubmit)} autoComplete="off">
                <Field component={UpwardReduxInput}
                    validate={[FormValidators.required]}
                    type="text" name="fname"
                    id="fname" placeholder="First name"
                    controlledValue={props.fname}
                    onChange={e => props.updateFName(e.target.value)}/><br />
                <Field component={UpwardReduxInput}
                    type="text" name="lname"
                    validate={[FormValidators.required]}
                    id="lname" placeholder="Last name"
                    controlledValue={props.lname}
                    onChange={e => props.updateLName(e.target.value)}/>
                 <h3 style={{ marginTop: '20px' }}>Work History</h3>
                <Field component={UpwardReduxInput} type="text" name="jobTitle"
                    id="jobTitle" placeholder="Most recent job title"
                    validate={[FormValidators.required]}
                    onChange={e => props.updateRecentJob(e.target.value)}/><br />
                <Field component={UpwardReduxInput} type="text" name="company"
                    id="company" placeholder="Company Name"
                    validate={[FormValidators.required]}
                    onChange={e => props.updateRecentCompany(e.target.value)} />
                <br />
                <div className="text-center"><button type="submit" className="btn btnSmall fullwidth btn-block" onClick={() => setCount(count + 1)}>Create resume</button></div>
                <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
            </form>
        </Fragment>
    )

}

export default reduxForm({
    form: 'EasyApplyForm',
})(EasyApplyForm);
